import React from "react";
import { connect } from "react-redux";
import moment from "moment";

import './style.css';
import ReactComponent from "../ReactComponent";
import LayoutWrapper from '../../layouts/LayoutWrapper.js';
import {
	Table,
	Button,
	InputNumber,
	Spin,
	Form,
	Input,
	DatePicker,
	TreeSelect,
	Select,
	Modal,
	Row,
	Col,
	message
} from 'antd';
import attendanceRecordService from '../../services/Attendance/attendance-record-service';
import { fetchDepartmentsList } from '../../actions/department-structure-actions.js';
const webConfig = require ('../../config.json');

const Option = Select.Option;


class AttendanceAmendRelaxationRecord extends ReactComponent {

	dataMode = 1
	state = {
		currentModalStatus:false,
		filters: {
			current_record_date: "",
			department_id: "",
			real_name: "",
			job_number: "",
			page: 1
		},
		data: [],
		dataStatus: "unload",
		relaxation_type:[{id:1,name:"普通"},{id:2,name:"因公"}]
	}


	actions = {
		selectAction: attendanceRecordService.selectRelaxationRecord,
		exportAction:attendanceRecordService.exportRelaxationRecord,
	}

	customComponentWillMount() {
		//this.props.fetchDepartmentsList();
		
		var date = new Date()
		var startyear = 2010
		var endyear = date.getFullYear()
		var res = [];
		for(var i = 0 ; endyear - i >= startyear; i++) {
			res.push(endyear - i)
		}
		this.setState({
			yearList:res
		})
	}

	setStartDateFilter = value => {
		this.setState({
		dataStatus: "loading",
			filters: {
				...this.state.filters,
				search_start_time: moment(value).format() ,
				page: 1
			}
		}, 
		this.reloadAction)
	}
	

	setEndDateFilter = value => {
		this.setState({
		dataStatus: "loading",
			filters: {
				...this.state.filters,
				search_end_time: moment(value).format() ,
				page: 1
			}
		}, 
		this.reloadAction)
	}

	setPageFilter = pagination => this.setState({
		dataStatus: "loading",
		filters: {
			...this.state.filters,
			page: pagination.current
		}
	}, this.reloadAction)

	setEmployeeFilter = value => this.setState({
		dataStatus: "loading",
		filters: {
			...this.state.filters,
			employee_info: value,
		}
	}, this.reloadAction)

	setDepartmentFilter = value => this.setState({
		dataStatus: "loading",
		filters: {
			...this.state.filters,
			department_id: value + ""
		}
	}, this.reloadAction)

	setChangeEmployeeFilter = event => {
		if (!event.target.value) {
			this.setEmployeeFilter();
		}
	}

	exportAttendance = () => {
		let gets = {};
		Object.keys(this.state.filters).forEach(key => {
			if (this.state.filters[key]) {
				gets[key] = this.state.filters[key];
			}
		});
		delete gets.page;
		this.publicExport(gets);
	}

	renderTreeNodes = data => data.map(item => {
		if (item.children) {
			return (
				<TreeSelect.TreeNode title={item.name}
					value={item.id + ""}
					key={item.id}
					dataRef={item}>
						{this.renderTreeNodes(item.children)}
				</TreeSelect.TreeNode>
			);
		}
		return <TreeSelect.TreeNode {...item} />
	})
	adjustRelaxation = (record, index) => {
		this.setState({
			adjustInfo:{
				...record,
				Relaxation_Type:1,
				over_type:1
			},
			currentModalStatus:true,
			statistic_id:record.id
		})		
	}
	
	adjustRelaxationSetType = (value) => {
		this.setState({
			adjustInfo:{
				...this.state.adjustInfo,
				Relaxation_Type :value,
				over_type:value
			}
		})		
	}
	
	adjustRelaxationSethour  = (value) => {
		this.setState({
			adjustInfo:{
				...this.state.adjustInfo,
				hours  :value
			}
		})		
	}
	
	adjustRelaxationSave  = () => {
		// var data=this.state.adjustInfo;
		// if((!data.Relaxation_Type)){
		// 	message.error("请选择调整类型");
		// 	return;
		// }	
		// if((!data.hours)||data.hours===0 ){
		// 	message.error("请填写调整小时数");
		// 	return;
		// }	
		this.props.form.validateFields((err, values) => {
			let posts = {
				...values,
				relaxation_statistic_id:this.state.statistic_id
			};
			
		attendanceRecordService.adjustRelaxation(posts,res=>{
			if(res.data.Success){
				message.success("调整完成");
				this.closeCurrentModal();
				this.setState({
					dataStatus: "loading",
					filters: {
						...this.state.filters,
					}
				}, this.reloadAction)
			}
			else{
				message.error(res.data.Errors[0]);
			}
		},err=>{
			message.error("调整失败");
		}
		)
	})
}
	closeCurrentModal = ()=>{
		this.setState({
			currentModalStatus:false,
			adjustInfo:null
		})
	}


//导出
publicExport = () => {
	let gets = {};
	Object.keys(this.state.filters).forEach(key => {
		if (this.state.filters[key]) {
			gets[key] = this.state.filters[key];
		}
	})
	delete gets.page;
	let ref = Modal.info({
		content: "正在准备需要下载的文件, 下载文件可能被浏览器阻挡, 请注意！"
	});
	if ("function" === typeof this.actions.exportAction) {
		this.actions.exportAction(gets, res => {
			ref.destroy();
			if (res.data.Success) {
				window.open(res.data.Message);
			}else{
				message.error('导出数据失败, ' + res.data.Errors[0], 4);
			}
		}, err => message.error('导出数据失败, 请联系管理员', 4))
	}else{
		this.handleError("Child class's actions exportAction is required!");
	}
}



	render () {
		
        const { currentUser } = this.props.user
		// var date = new Date()
		// var endyear = date.getFullYear()
		// const yearList=this.state.yearList
		const column = [
			{
				title: '工号',
				dataIndex: 'job_number',
				key: 'job_number',
				className: "table-global-head"
			}, {
				title: '中文名',
				dataIndex: 'real_name',
				key: 'real_name',
				className: "table-global-head",				
			}, {
				title: '英文名',
				dataIndex: 'english_name',
				key: 'english_name',
				className: "table-global-head"
			},{
				title: '部门',
				dataIndex: 'department_name',
				key: 'department_name',
				className: "table-global-head"
			}, {
				title: '月份',
				dataIndex: 'month',
				key: 'month',
				className: "table-global-head"
			}, {
				title: '本月普通加班',
				dataIndex: 'common_over_time_hours',
				key: 'common_over_time_hours',
				className: "table-global-head"
			}, {
				title: '本月因公加班',
				dataIndex: 'formal_over_time_hours',
				key: 'formal_over_time_hours',
				className: "table-global-head"
			}, {
				title: '本月普通调休',
				dataIndex: 'common_relaxation_hours',
				key: 'common_relaxation_hours',
				className: "table-global-head"
			}, {
				title: '本月因公调休',
				dataIndex: 'formal_relaxation_hours',
				key: 'formal_relaxation_hours',
				className: "table-global-head"
			},{
				title: '上月结余普通调休',
				dataIndex: 'common_last_left_hours',
				key: 'common_last_left_hours',
				className: "table-global-head"
			},{
				title: '上月结余因公调休',
				dataIndex: 'formal_last_left_hours',
				key: 'formal_last_left_hours',
				className: "table-global-head"
			}, {
				title: '本月剩余普通调休',
				dataIndex: 'common_left_hours',
				key: 'common_left_hours',
				className: "table-global-head"
			}, {
				title: '本月剩余因公调休',
				dataIndex: 'formal_left_hours',
				key: 'formal_left_hours',
				className: "table-global-head"
			}, {
				title: '月末需作废普通调休',
				dataIndex: 'common_to_undo_hours',
				key: 'common_to_undo_hours',
				className: "table-global-head"
			},{
				title: '月末需作废因公调休',
				dataIndex: 'formal_to_undo_hours',
				key: 'formal_to_undo_hours',
				className: "table-global-head"
			}, {
				title: '下月可普通调休',
				dataIndex: 'common_use_next_month_hours',
				key: 'common_use_next_month_hours',
				className: "table-global-head"
			},{
				title: '下月可因公调休',
				dataIndex: 'formal_use_next_month_hours',
				key: 'formal_use_next_month_hours',
				className: "table-global-head"
			}, {
				title: '操作',
				dataIndex: 'action',
				key: 'action',
				className: "daily-report-action",
				render: (text, record, index) => (
						<span>
							 <Button icon="info-circle-o" size="small" className="row-action-btn"
								onClick={this.adjustRelaxation.bind(this, record, index, true)}>调整</Button>
						</span>
				)
    	}
		];
		return (
			<div className="app-module-item">
			<Modal width="600px"
					visible={this.state.currentModalStatus}
					title= {"调整调休"}
					destroyOnClose={true}
					onCancel={this.closeCurrentModal}
					footer={null}>
					
					{this.state.adjustInfo&&<Form onSubmit={this.submitCurrentModal} className="login-form" layout="inline">
							<div style={{paddingLeft:"100px"}}>
								<Form.Item label="待调员工" className='AttendanceSchedule' >
									{this.props.form.getFieldDecorator('user', {
										initialValue: this.state.adjustInfo.real_name?this.state.adjustInfo.real_name:this.state.adjustInfo.english_name
									})(<span>{this.state.adjustInfo.real_name?this.state.adjustInfo.real_name:this.state.adjustInfo.english_name} - {this.state.adjustInfo.department_name}</span>)}
								</Form.Item>
							</div>
							<div style={{paddingLeft:"100px"}}>
								<Form.Item label="调整月份" className='AttendanceSchedule'>
									{this.props.form.getFieldDecorator('month', {
										initialValue: this.state.adjustInfo.month
									})(<span>{this.state.adjustInfo.month}</span>)}
								</Form.Item>
							</div>
							{/* <div style={{paddingLeft:"100px"}}>
								<Form.Item label="调整类型" className='AttendanceSchedule' width="150px">
									{this.props.form.getFieldDecorator('type', {
										rules: [{ required: true, message: '选择调整类型' }],
										initialValue: 1
									})(<Select initialValue={1} width="250px" onChange={this.adjustRelaxationSetType}>
									{this.state.relaxation_type.map(x=><Option value={x.id}>{x.name}</Option>)}
								</Select>)}
								</Form.Item>
							</div>
							<div style={{paddingLeft:"100px"}}>
								<Form.Item label="调整小时数" className='AttendanceSchedule' width="150px">
									{this.props.form.getFieldDecorator('hours', {
										rules: [{ required: true, message: '请输入班次' }],
										initialValue: 0
									})(<InputNumber  initialValue={0}   width="250px" onChange={this.adjustRelaxationSethour} />)}
								</Form.Item>
							</div> */}
							<div style={{paddingLeft:"100px"}}>
								<Form.Item label="普通加班" className='AttendanceSchedule' width="150px">
									{this.props.form.getFieldDecorator('common_work_hours', {
										rules: [{ required: true, message: '请输入数值' }],
										initialValue: 0
									})(<InputNumber  initialValue={0}   width="250px" />)}
								</Form.Item>
								</div>
								<div style={{paddingLeft:"100px"}}>
								<Form.Item label="因公加班" className='AttendanceSchedule' width="150px">
									{this.props.form.getFieldDecorator('formal_work_hours', {
										rules: [{ required: true, message: '请输入数值' }],
										initialValue: 0
									})(<InputNumber  initialValue={0}   width="250px" />)}
								</Form.Item>
								</div>
								<div style={{paddingLeft:"100px"}}>
								<Form.Item label="普通调休" className='AttendanceSchedule' width="150px">
									{this.props.form.getFieldDecorator('common_work_hours_used', {
										rules: [{ required: true, message: '请输入数值' }],
										initialValue: 0
									})(<InputNumber  initialValue={0}   width="250px" />)}
								</Form.Item>
								</div>
								<div style={{paddingLeft:"100px"}}>
								<Form.Item label="因公调休" className='AttendanceSchedule' width="150px">
									{this.props.form.getFieldDecorator('formal_work_hours_used', {
										rules: [{ required: true, message: '请输入数值' }],
										initialValue: 0
									})(<InputNumber  initialValue={0}   width="250px" />)}
								</Form.Item>
							</div>
							<div style={{paddingLeft:"100px"}}>
								<Form.Item label="上月结余普通" className='AttendanceSchedule' width="150px">
									{this.props.form.getFieldDecorator('last_left_common_work_hours', {
										rules: [{ required: true, message: '请输入数值' }],
										initialValue: 0
									})(<InputNumber  initialValue={0}   width="250px" />)}
								</Form.Item>
							</div>
							<div style={{paddingLeft:"100px"}}>
								<Form.Item label="上月结余因公" className='AttendanceSchedule' width="150px">
									{this.props.form.getFieldDecorator('last_left_formal_work_hours', {
										rules: [{ required: true, message: '请输入数值' }],
										initialValue: 0
									})(<InputNumber  initialValue={0}   width="250px" />)}
								</Form.Item>
							</div>
					</Form>}
					{/* <Row style={{margin:'10px'}}>
						<Col span={10} style={{textAlign:'right',paddingRight:"10px"}}>
						调整类型：
						</Col>
						<Col span={14} >
						<Select defaultValue={1} width="250px" onChange={this.adjustRelaxationSetType}>
							{this.state.relaxation_type.map(x=><Option value={x.id}>{x.name}</Option>)}
						</Select>
						</Col>
					</Row>
					
					<Row style={{margin:'10px'}}>
						<Col span={10} style={{textAlign:'right',paddingRight:"10px"}}>
						调整小时数：
						</Col>
						<Col span={14} >
						<InputNumber  defaultValue={0}   width="250px" onChange={this.adjustRelaxationSethour} />
						</Col>
					</Row> */}
					<Row style={{margin:'10px'}}>
						<Col span={22} style={{textAlign:'center'}}>
						{currentUser.PermissionDict.amendrelaxation.adjust_relaxation_value&&<Button key="关闭" onClick={this.adjustRelaxationSave} >确定</Button>}
						</Col>
					</Row>
			</Modal>
				<div style={{marginBottom: "0px"}}>
					<div className="colAction" style={{float:"right", margin:"0px 10px 10px 0px"}}>
						<Input.Search
							placeholder="报告人 工号/姓名"
							onSearch={this.setEmployeeFilter}
							onChange={this.setChangeEmployeeFilter}
							style={{ width: 200 }}
							defaultValue={null}
							enterButton />
					</div>
					<div className="colAction" style={{float:"right", margin:"0px 10px 10px 0px"}}>
						<Form layout="inline" style={{float:'left'}}>
							<Form.Item>
							{this.props.form.getFieldDecorator('department_id', {
								rules: [],
								initialValue: this.state.filters.department_id
							})(<TreeSelect style={{minWidth:"300px"}}
									placeholder="请选择部门"
									showSearch={false}
									autoExpandParent={true}
									dropdownStyle={{ maxHeight: 400, overflow: 'auto' }}
									treeDefaultExpandAll
									onChange={this.setDepartmentFilter}>
										{ this.props.departmentStructure.departmentsList &&
										this.renderTreeNodes(this.props.departmentStructure.departmentsList) }
								</TreeSelect>
							)}
							</Form.Item>
						</Form>
					</div>	
					<div className="colAction" style={{float:"right", margin:"0px 10px 10px 0px"}}>
						<span style={{marginRight:"5px"}}>结束日期 : </span>
    						<DatePicker  onChange={this.setEndDateFilter}/>
					</div>
					
					<div className="colAction" style={{float:"right", margin:"0px 10px 10px 0px"}}>
						<span style={{marginRight:"5px"}}>开始日期 : </span>
    						<DatePicker  onChange={this.setStartDateFilter}/>
					</div>
					<div key={1} className="colAction"
						style={{float:"left", margin:"0px 10px 10px 0px"}}>
						<Button icon={"cloud-download-o"}
							type={ "primary"}
							size={ "default"}
							onClick={this.publicExport} >
							<span>{"导出"}</span>
						</Button>
					</div>
					<div style={{clear:"both"}}></div>
				</div>
				<div>
					单位：小时
					{(() => {
						switch (this.state.dataStatus) {
							case "loaded":
								return (
									<Table columns={column}
									dataSource={this.state.data.Data}
									scroll={{x: 800}}
									rowKey={(record, index) => index}
									pagination={{
											total: this.state.data.Total,
											pageSize: this.state.data.PageSize,
											current: this.state.filters.page}}
									onChange={this.setPageFilter} />)
							case "error":
								return (
									<div style={{textAlign:'center', margin: '100px 0px'}}>
										{webConfig.httpFetchErrorInformation}
									</div>);
							case "loading":
							case "reload":
							case "unload":
								return (
									<div style={{textAlign:'center', margin: '100px 0px'}}>
										<Spin size="large" />
									</div>);
							default :
								return null;
						}
					})()}
				</div>
			</div>
		)
	}
}

const mapStateToProps = state => {
	return {
		departmentStructure: state.departmentStructure,
        user: state.user
	}
}

const mapDispatchToProps = {
	fetchDepartmentsList
}

AttendanceAmendRelaxationRecord = Form.create()(AttendanceAmendRelaxationRecord)

export default LayoutWrapper(connect(mapStateToProps, mapDispatchToProps)(AttendanceAmendRelaxationRecord));









// WEBPACK FOOTER //
// ./src/routes/Attendance/AttendanceAmendRelaxation.js